import {useEffect,useState} from 'react';
import GlbHdrUi from 'Views/Glb/GlbHdrUi';
import GlbFtrUi from 'Views/Glb/GlbFtrUi';
import {Outlet, useOutletContext,useLocation, useNavigate} from 'react-router-dom';
import CustomizedAccordions from './CbtMypaheAcco';
import IsMntnInqApi from 'Apis/IsMntnInqApi';
import GameMainPageApi from 'Apis/GameMainPageApi';
import MgpStore from 'Stores/Store';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import GameSubHdrUi from 'Views/Game/GameSubHdrUi'
import GameTstrApi from 'Apis/GameTstrApi';
import ApiError from 'Utils/ApiError';
import ApiResultModal from 'Components/ApiResultModal';

const LeftMenuLayout = () => {
    const location= useLocation();  
    let gameSvcCd:any;
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    if(getGameSvcCd == undefined) {
        gameSvcCd = "BBO";
    }else {
        gameSvcCd = getGameSvcCd
    }

    const [gameMainPageData,setGameMainData] = useState();
    const navigate = useNavigate();
    const [isHdrFixed, setIsHdrFixed] = useState(false);
    const [mntnData, setMntnData] = useState<any>(null);
    const [tstrData, setTstrData] = useState<any>(null);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    useEffect(()=>{
        IsMntnInqApi(gameSvcCd)
        .then((resp)=>{
            // 해당 gameSvcCd에 맞는 게임 서비스 찾기
            const targetGame = resp.find((game: any) => game.gameSvcCd === gameSvcCd);
            if(targetGame && targetGame.isMntn === "Y") {
                return window.location.href = "/mntn?gameSvcCd="+gameSvcCd;
            }
        });
        IsMntnInqApi(gameSvcCd)
        .then((resp)=>{
            
            // 점검 데이터 저장
            setMntnData(resp.apiBody);
            
            // MGP 본체 점검 확인 (본체 점검 시 모든 페이지 차단)
            const mgpMntnInfo = resp.apiBody?.find((item: any) => item.gameSvcCd?.toUpperCase() === "MGP");
            
            
            if(mgpMntnInfo && mgpMntnInfo.isMntn === "Y") {
            
                return navigate("/mntn?gameSvcCd=MGP", { replace: true, state: { mntnData: resp.apiBody } });
            }
            
        });
        GameTstrApi(gameSvcCd).then((resp)=> {
            switch(resp.apiHdr.code){
                case "GAME0000":
                    setTstrData(resp.apiBody);
                    break;
                default:
                    ApiError(langData, resp.apiHdr.code);
                break;
            }
        })
        GameMainPageApi(gameSvcCd).then((resp)=> {
            // API returns payload in apiBody — store consistently
            setGameMainData(resp.apiBody || resp);
            if((resp.apiBody || resp).rlsYn === "N"){
                openResultModal("페이지 준비중입니다.", () => {
                    window.location.href = "/";
                });
            }
        })
    },[])
    MgpStore.subscribe(() =>MgpStore.getState());
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    return (
        <>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData && langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            <div className='rootContainer BgW'>
                {gameMainPageData && (
                    <GameSubHdrUi  gameSvcCd={gameSvcCd} gameMainPageData={gameMainPageData} onFixedChange={setIsHdrFixed} mntnData={mntnData} tstrData={tstrData} />
                )}
                <div className='leftMenuContainer'>
                    <div className='leftMenuWrap myPageLeftMenu'>
                        <CustomizedAccordions  />
                    </div>
                    <Outlet context={langData}/>
                    <GlbFtrUi  gameSvcCd={"BBO"} gameMainPageData={gameMainPageData}/>
                </div>
            </div>
        </>
    );
  }
  export default LeftMenuLayout;